import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { dispatch, useGlobalState } from '../../store/state';
import { Button, Col, message, Result, Skeleton } from 'antd';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
// import BrandsTableComponent from '../../components/Admin/Brands/BrandsTableComponent';
import TopSubHeaderComponent from '../../components/Admin/Common/TopSubHeaderComponent';
import BrandsCompaniesTableComponent from '../../components/Admin/Brands/BrandsCompaniesTableComponent';
import { Link } from 'react-router-dom';

export const AdminBrandsCompaniesPage = () => {
  const [user] = useGlobalState('user');
  useEffect(()=>{
  }, []);

  return (
    <BaseLayoutComponent>
      <TopSubHeaderComponent className="px-3 py-2 sticky">
        <h6 className="m-0">
          <Link to="/admin/dashboard/brands">
            <Button type="link"
              className="px-0"><strong>Brands</strong></Button>
          </Link> &gt;
          <span> Companies</span></h6>
      </TopSubHeaderComponent>
      <div className="d-flex flex-wrap py-3">
        <div className="col-md-12">
          <BrandsCompaniesTableComponent/>
        </div>
      </div>
    </BaseLayoutComponent>
  );
};
